module.exports = __webpack_public_path__ + "static/teleco_13-6f102c69408c940081912ecf9cb80d4f.jpg";